import React, { lazy, useState } from 'react';
import DropdownMenu from '../../common/Dropdown.jsx';
import { FaIcon } from '../../common/Icons.jsx';
import Portal from '../../common/Portal.jsx';
import withSuspense from '../../../helpers/withSuspense.jsx';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';

const NewTaskForm = withSuspense(lazy(() => import('./NewTaskForm.jsx')), SkeletonGrid);
const NewWorkPackageForm = withSuspense(lazy(() => import('./NewWorkPackageForm.jsx')), SkeletonGrid);

function NewTaskButton({ btnStyle = {}, portalProps = {} }) {
  const [component, setComponent] = useState(null);

  const onClick = (e, nextComponent) => {
    e.preventDefault();
    setComponent(() => nextComponent);
  };

  const closePortal = () => setComponent(null);

  return (
    <>
      <DropdownMenu
        hideOnClick={true}
        btnStyle={btnStyle}
        label={
          <>
            <FaIcon type='plus' /> {I18n.t('add')} <FaIcon type='caret-down' />
          </>
        }
      >
        <li>
          <a className='dropdown-item' onClick={e => onClick(e, NewTaskForm)}>
            {I18n.t('task')}
          </a>
        </li>
        <li>
          <a className='dropdown-item' onClick={e => onClick(e, NewWorkPackageForm)}>
            {I18n.t('work_package')}
          </a>
        </li>
      </DropdownMenu>

      {component && (
        <Portal
          component={component}
          onClose={closePortal}
          {...portalProps}
        />
      )}
    </>
  );
}

export default NewTaskButton;
